import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { FeatureModel } from "@rightstore/Model/Feature.model";
import { PreviousPurchaseModel } from "@rightstore/Model/PreviousPurchase.model";
import { ProductPropertiesModel } from "@rightstore/Model/ProductProperties.model";
import { UspsModel } from "@rightstore/Model/Usps.model";

export default function useProductProperties(product: ProductModel): ProductPropertiesModel {
    return {
        overviewDescription: product.properties.overviewDescription,
        productType: product.properties.productType,
        usps: MapUsps(product.properties),
        features: MapFeatures(product.properties),
        youtubeVideoId: product.properties.youtubeVideoId,
        youtubeVideoTitle: product.properties.youtubeVideoTitle,
        previousPurchase: MapPreviousPurchase(product.properties),
        productIsComingSoon: product.properties.productIsComingSoon,
        productIsPlaceholder: product.properties.productIsPlaceholder,
        productTypeButtonText: product.properties.productTypeButtonText,
    }
}

function MapUsps(properties: { [key: string]: string }): UspsModel[] {
    return [1, 2, 3].map(index => {
        return {
            index,
            imageUrl: properties[`usp${index}Image`],
            title: properties[`usp${index}Title`],
            description: properties[`usp${index}Text`]
        }
    })
}

function MapFeatures(properties: { [key: string]: string }): FeatureModel[] {
    return [1, 2, 3, 4].map(index => {
        return {
            index,
            imageUrl: properties[`feature${index}Image`],
            title: properties[`feature${index}Title`],
            description: properties[`feature${index}Text`]
        }
    })
}

function MapPreviousPurchase(properties: { [key: string]: string }): PreviousPurchaseModel | undefined {
    return properties.previousPurchaseIsValid === 'true'
        ? {
            orderNumber: properties.previousPurchaseOrderNumber,
            validUntil: new Date(properties.previousPurchaseValidUntil),
            fulfillmentUrl: properties.previousPurchaseFulfillmentUrl
        }
        : undefined
}